import React from 'react';
import { HiEye } from 'react-icons/hi2';
import detailsPageHero from '../../assets/images/detailsPageHero.png';
import web1Img from '../../assets/images/web1.png';
import FadeIn from '../common/FadeIn';

const TemplateDetailsHero = ({ template }) => {
  const templateName = template?.name || 'Theme01';
  const price = template?.price || '$299';
  const subtitle = template?.subtitle || 'SEASALT CREATIVE TEMPLATE';
  const tagline = template?.tagline || 'Luxe, Chic, Statement-Making';
  const heroMockupImg = template?.img || web1Img;

  return (
    <div className="w-full bg-[#f9f9f5] text-[#1C1917] relative overflow-x-hidden">

      <div
        className="relative w-full min-h-[380px] sm:min-h-[440px] md:min-h-[480px] lg:min-h-[560px] bg-cover bg-center bg-no-repeat overflow-hidden flex items-center"
        style={{ backgroundImage: `url(${detailsPageHero})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-black/50" />
        <div className="absolute inset-0 bg-[#1C1917]/25" />

        <div className="relative w-full max-w-[1360px] mx-auto px-4 sm:px-6 lg:px-8 pb-8 sm:pt-[288px] sm:pb-12 z-10">

          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-10 items-center">

            <div className="hidden md:block md:col-span-6 lg:col-span-6" />

            <div className="md:col-span-6 lg:col-span-6 flex flex-col items-center md:items-start text-center md:text-left">
              <FadeIn>
                <h1 className="font-saolDisplayItalic text-[white] leading-[1.2] tracking-[0.05em] font-normal text-[34px] md:text-[44px]">
                  {templateName}
                </h1>
              </FadeIn>

              <FadeIn>
                <span className="font-interDisplayMedium md:text-[12px] text-[11px] text-[white] font-normal leading-[2] tracking-[0.2em] mt-2 block">
                  {subtitle}
                </span>
              </FadeIn>

              <FadeIn>
                <div className="w-14 h-[1px] bg-white my-3 md:my-4" />
              </FadeIn>

              <FadeIn>
                <p className="font-PromenadeItalic text-[white] leading-[1.2] text-[28px] md:text-[24px] md:leading-[1.3] tracking-[0.015em] font-normal max-w-sm md:max-w-none">
                  {tagline}
                </p>
              </FadeIn>
            </div>

          </div>

        </div>
      </div>

      <div className="max-w-[1360px] mx-auto px-4 sm:px-6 lg:px-8 -mt-24 sm:-mt-36 md:-mt-48 lg:-mt-64 relative z-10 pb-16 lg:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-10 items-start">

          <div className="md:col-span-6 lg:col-span-6 flex justify-center md:justify-start">
            <FadeIn className="w-full max-w-[600px] flex justify-center md:justify-start">
              <div
                className="w-[274px] md:w-[600px] max-w-full h-[426px] md:h-[540px] lg:h-[800px] overflow-hidden rounded-sm shadow-2xl relative group cursor-pointer bg-transparent"
              // style={{
              //   filter: 'drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.1))',
              // }}
              >
                <img
                  src={heroMockupImg}
                  alt={`${templateName} Website Template Design Preview`}
                  className="w-full h-auto object-cover object-top block transform translate-y-0 transition-transform duration-[4s] ease-in-out group-hover:-translate-y-[calc(100%-426px)] md:group-hover:-translate-y-[calc(100%-540px)] lg:group-hover:-translate-y-[calc(100%-800px)]"
                  loading="eager"
                  decoding="async"
                  width="600"
                  height="800"
                />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-6 lg:col-span-6 flex flex-col justify-start text-left pt-6 md:pt-[208px] lg:pt-[352px]">

            <div className="md:hidden mb-4">
              <FadeIn>
                <span className="font-interDisplayMediums text-[10px] uppercase tracking-[0.25em] text-[#8C7355] font-semibold block mb-1">
                  {subtitle}
                </span>
              </FadeIn>

              <FadeIn>
                <p className="font-PromenadeItalic text-lg text-[#574D43] italic">
                  {tagline}
                </p>
              </FadeIn>
            </div>

            <FadeIn>
              <h2 className="font-saolDisplayItalic text-[34px] md:text[36px] leading-[1.3] tracking-[0.015em] font-normal mb-4">
                {templateName}
              </h2>
            </FadeIn>

            <FadeIn>
              <p className="font-interDisplayMediums text-[15px] md:text-base leading-[1.6] tracking-[0.05em] font-normal mb-6 md:mb-0 max-w-xl">
                A clean and responsive website theme made for businesses, creatives, and professionals. The design is ready to use and can be customized with your text, images, logo, colors, and brand details. Each section can be adjusted to fit your content and requirements. The layout is simple, modern, and easy to navigate.
              </p>
            </FadeIn>
            <FadeIn>
              <p className="font-interDisplayMediums text-[15px] md:text-base leading-[1.6] tracking-[0.05em] font-normal mb-6 md:mb-0 max-w-xl">
                works smoothly on desktop, tablet, and mobile screens. You can keep the original design or make changes to match your style. I will handle the customization and make the required updates for you. A simple way to get a professional website without starting everything from scratch.
              </p>
            </FadeIn>

            <FadeIn>
              <div className="mb-4 pt-1">
                <div className="flex items-baseline gap-2 mt-0.5">
                  {/* <span className="font-PromenadeItalic leading-[1.4] tracking-[0.015em] text-[22px] font-normal uppercase">Setup Fee:</span>
                  <span className="font-saolDisplayItalic leading-[1.4] tracking-[0.015em] text-[22px] font-bold">
                    {price}
                  </span> */}
                </div>
              </div>
            </FadeIn>

            <FadeIn>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href={template?.demoUrl || template?.externalUrl || (template?.slug === 'theme02' || template?.id % 2 === 0 ? '/themes/theme02/index.html' : '/themes/theme01/index.html')}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3.5 bg-[#ce884d] text-[#ffffff] font-montserratMedium text-[9px] lg:text-[11px] font-semibold hover:bg-[#ccc3ad] hover:text-black transition-all duration-[0.5s] uppercase tracking-[0.18em] rounded-xs flex items-center justify-center gap-2 cursor-pointer"
                >
                  <HiEye className="w-4 h-4" />
                  <span>VIEW LIVE DEMO</span>
                </a>
              </div>
            </FadeIn>

          </div>

        </div>
      </div>

    </div>
  );
};

export default TemplateDetailsHero;
